@import 'src/styles/common/_colors.scss';

.tisccCheckbox {
	display: flex;
	gap: 12px;
	align-items: center;
	%checked {
		background: linear-gradient(to bottom, $light-green-variant-1 0%, $light-green 100%);
	}

	%checked--active {
		background: linear-gradient(to bottom, $light-green 0%, $light-green-variant-1 100%);
	}

	.tisccCheckboxInput {
		flex: 0 0 auto;
		height: 15px;
		line-height: 14px;
		margin: 0;
		opacity: 1;
		padding: 0;
		position: relative;
		width: 15px;
		left: 7px;
		&:after {
			background: linear-gradient(180deg, $gray-variant-9 0, $gray-variant-10);
			border-radius: 2px;
			border: 1px solid $black;
			content: "";
			cursor: pointer;
			display: block;
			font-family: "icomoon";
			font-size: 12px;
			height: inherit;
			left: 0;
			line-height: inherit;
			position: absolute;
			top: 0;
			width: inherit;
		}

		&.indeterminate {
			&:after {
				@extend %checked;
				content: "\25a0" !important;
				line-height: 8px;
				text-align: center;
			}

			&:active {
				&:after {
					@extend %checked--active;
				}
			}
		}
		&.labelDisabled{
			left: 0;
		}

		&:checked {
			&:after {
				@extend %checked;
				content: "\e609";
			}

			&:active {
				&:after {
					@extend %checked--active;
				}
			}
		}

		&:not(.indeterminate) {
			&:not(:checked):not([disabled]) {
				&:hover {
					&:after {
						background: linear-gradient(to bottom, $light-gray-variant-1 0%, $light-gray-variant-2 100%);
					}
				}

				&:active {
					&:after {
						background: linear-gradient(to bottom, $gray-variant-10 0%, $gray-variant-9 100%);
					}
				}
			}
		}

		&[disabled] {
			cursor: default;

			&:after {
				background: linear-gradient(to bottom, $radio-button-background-5 0%, $background-variant-1 100%);
				color: $gray-variant-9;
				cursor: default;
			}

			+ label {
				color: $label;
				cursor: default;
				pointer-events: none;
			}
		}
	}

	.tisccCheckboxlabel {
		cursor: pointer;
		display: inline-block;
		margin: 0;
		padding: 0;
		white-space: nowrap;		
		line-height: 1.25rem;
		text-align: center;
	}
}
